import { UniButton } from '@/design-system/components/buttons';
import { H6, TextBody, TextCaption } from '@/design-system/components/typography';
import { SxProp, View } from 'dripsy';
import _ from 'lodash';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/design-system/components/icons/Icon';
import { MobileNo } from '@/features/account-management/types';
import { LayoutContext } from 'contexts/LayoutContext';
import moment from 'moment-timezone';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { UpdateMobileNoStackParamList } from '@/features/account-management/screens/update-mobile-no/type';
import { Card } from '@utx/utx-access-client';

export interface UpdateMobileNoProps {
  onClose: () => void;
  data: MobileNo;
  onLayout: (event: any) => void;
  returnData?: any;
  refresh?: () => void;
  record?: Card;
}

export const UpdateMobileNoWebTwoScreen: React.FC<UpdateMobileNoProps> = (props) => {
  const { onClose, data, onLayout, returnData, refresh } = props;
  const { t } = useTranslation('account-management');
  const layout = useContext(LayoutContext);
  const {
    topHeader,
    body,
    horizontalWrapper,
    textLabel,
    textDebitAmount,
    textTitle,
    textAtmPin,
    timeView,
    refView,
    textHeaderTitle,
    textHeaderSubTitle,
    btn
  } = sxStyles;

  const navigation = useNavigation<NativeStackNavigationProp<UpdateMobileNoStackParamList>>();
  const [instructionTime, setInstructionTime] = useState(moment().format('YYYY-MM-DD HH:mm:ss'));

  return (
    <View
      sx={{
        height: layout.isMobile ? '100%' : 'auto',
        width: layout.dimensions.width,
        maxWidth: layout.isMobile ? layout.dimensions.width : Math.min(500, layout.dimensions.width),
        backgroundColor: '$backgroundPrimary'
      }}
      onLayout={(event) => {
        onLayout(event);
      }}>
      <View sx={topHeader}>
        <Icon name="checkCircleBlue" height={90} width={90} />
        <H6 bold sx={textHeaderTitle}>
          {t('card-account-management::replace-card.title--update-mobile-number-placed')}
        </H6>
        <TextCaption sx={textHeaderSubTitle}>{t('card-account-management::replace-card.text--mobile-number-updated')}</TextCaption>
      </View>
      <View sx={body}>
        <TextCaption sx={textTitle} semiBold>
          {t('card-account-management::replace-card.text--new-mobile-number')}
        </TextCaption>
        <H6 sx={textAtmPin}>
          +{data?.phoneCode} {data?.phoneNumber}
        </H6>
        <View
          sx={{
            ...horizontalWrapper,
            ...timeView
          }}>
          <TextBody sx={textLabel}>{t('card-account-management::glossary.instruction-time')}</TextBody>
          <TextBody sx={textDebitAmount}>{returnData?.instructionTime || instructionTime || '-'}</TextBody>
        </View>
        <UniButton
          sx={btn}
          label={t('card-account-management::lock-card.button--return')}
          onPress={() => {
            refresh && refresh();
            navigation.getParent()?.goBack();
          }}
        />
      </View>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  topHeader: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'primaryDefault',
    mt: '$10',
    gap: '$2'
  },
  body: {
    minHeight: 200,
    minWidth: 500,
    px: 28,
    py: 28
  },
  horizontalWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  textLabel: {
    color: '$textSecondary'
  },
  textDebitAmount: {
    mb: '$1',
    color: '$textPrimary'
  },
  textTitle: {
    marginBottom: 4,
    color: '$textSecondary'
  },
  textAtmPin: {
    fontWeight: 'bolder',
    color: '$textThemeSecondary'
  },
  timeView: {
    mb: '$3',
    mt: '$5'
  },
  refView: {
    mb: '$10'
  },
  textHeaderTitle: {},
  textHeaderSubTitle: {
    color: '$textPrimary'
  },
  btn: {
    width: '100%',
    height: 44
  }
};
